import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const {
    user
  } = useAuth();
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <nav className="bg-white shadow-md sticky top-0 z-50" data-id="element-576">
      <div className="container-custom" data-id="element-577">
        <div className="flex justify-between items-center py-4" data-id="element-578">
          <Link to="/" className="flex items-center space-x-2" onClick={closeMenu} data-id="element-579">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2uA1NcZWoYpSDnSLsJh3Vq/operation-launchpad-logo.png" alt="Operation Launchpad" className="h-10" data-id="element-580" />
          </Link>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-581">
            <button onClick={toggleMenu} className="text-navy hover:text-orange focus:outline-none" aria-label="Toggle menu" data-id="element-582">
              {isOpen ? <XIcon size={24} data-id="element-583" /> : <MenuIcon size={24} data-id="element-584" />}
            </button>
          </div>
          {/* Desktop menu */}
          <div className="hidden md:flex md:items-center md:space-x-8" data-id="element-585">
            <NavLink to="/" active={isActive('/')} onClick={closeMenu} data-id="element-586">
              Home
            </NavLink>
            <NavLink to="/about" active={isActive('/about')} onClick={closeMenu} data-id="element-587">
              About Us
            </NavLink>
            <NavLink to="/programs" active={isActive('/programs')} onClick={closeMenu} data-id="element-588">
              Programs
            </NavLink>
            <NavLink to="/impact" active={isActive('/impact')} onClick={closeMenu} data-id="element-589">
              Impact
            </NavLink>
            <NavLink to="/enews" active={isActive('/enews')} onClick={closeMenu} data-id="element-590">
              eNews
            </NavLink>
            <NavLink to="/contact" active={isActive('/contact')} onClick={closeMenu} data-id="element-591">
              Contact
            </NavLink>
            {user ? <NavLink to="/dashboard" active={isActive('/dashboard')} onClick={closeMenu} data-id="element-592">
                Dashboard
              </NavLink> : <Link to="/apply" onClick={closeMenu} data-id="element-593">
                <button className="btn-primary" data-id="element-594">Apply Now</button>
              </Link>}
          </div>
        </div>
        {/* Mobile menu */}
        {isOpen && <div className="md:hidden" data-id="element-595">
            <div className="flex flex-col space-y-4 pt-2 pb-4" data-id="element-596">
              <NavLink to="/" active={isActive('/')} onClick={closeMenu} data-id="element-597">
                Home
              </NavLink>
              <NavLink to="/about" active={isActive('/about')} onClick={closeMenu} data-id="element-598">
                About Us
              </NavLink>
              <NavLink to="/programs" active={isActive('/programs')} onClick={closeMenu} data-id="element-599">
                Programs
              </NavLink>
              <NavLink to="/impact" active={isActive('/impact')} onClick={closeMenu} data-id="element-600">
                Impact
              </NavLink>
              <NavLink to="/enews" active={isActive('/enews')} onClick={closeMenu} data-id="element-601">
                eNews
              </NavLink>
              <NavLink to="/contact" active={isActive('/contact')} onClick={closeMenu} data-id="element-602">
                Contact
              </NavLink>
              {user ? <NavLink to="/dashboard" active={isActive('/dashboard')} onClick={closeMenu} data-id="element-603">
                  Dashboard
                </NavLink> : <Link to="/apply" onClick={closeMenu} data-id="element-604">
                  <button className="btn-primary w-full" data-id="element-605">Apply Now</button>
                </Link>}
            </div>
          </div>}
      </div>
    </nav>;
};
const NavLink = ({
  to,
  active,
  onClick,
  children
}) => {
  return <Link to={to} onClick={onClick} className={`font-medium transition duration-300 ${active ? 'text-orange' : 'text-navy hover:text-orange'}`} data-id="element-606">
      {children}
    </Link>;
};
export default Navbar;